export const blockedElemId = 'a70273f4-b155-5430-b63f-d2ca2fabcc27';

export function isBlockingAds() {
  return !document.getElementById(blockedElemId);
}
